module.exports = __webpack_public_path__ + "static/media/bg-waves.57ba0307.svg";